module.exports = __webpack_public_path__ + "img/tag_green_pin.0ee90f34.svg";